/**
 * Resolves a path to a file in `public/` for the current deploy base (`homepage` / PUBLIC_URL).
 * Use for any `src` or `href` that points at `public/` instead of webpack-bundled assets.
 */
export function publicUrl(assetPath) {
  if (!assetPath) return '';
  if (/^https?:\/\//i.test(assetPath)) return assetPath;
  const base = process.env.PUBLIC_URL || '';
  const path = String(assetPath).replace(/^\/+/, '');
  return `${base}/${path}`;
}
